import { gql } from '@apollo/client';
import { getProductFragment } from '../product/getProductQuery';

const getFBTQuery = ({ productDomains = [] }) => {

  const productFragments = getProductFragment({ domains: productDomains });

  const params = [
    '$itemId: String!',
    '$storeId: String'
  ];

  const BundleQuery = `
    query Bundle(${params.join(', ')}) {
      bundle(itemId: $itemId, storeId: $storeId) {
        metadata {
          apiName
          title
          version
          modelName
          fallbackModelName
          type
          __typename
        }
        products {
          product {
            ${productFragments.query}
          }
          idStartDate
          idEndDate
          idPromoDetails
          category
          description
          isAnchor
          slot {
            name
            description
            isRequired
          }
          __typename
        }
        __typename
      }
    }
    ${productFragments.fragments}
`;
  return gql(BundleQuery);
};
export default getFBTQuery;
